import { useTranslation } from '@/app/components/translations/Translation.tsx';
import { Text } from '@lmn/design-system';
import { CheckDateTime } from '@/app/components/hotel-detail/HotelCheckinCheckout.tsx';
import React from 'react';
import styled from 'styled-components';

const TransportDetailsTitle = styled.div`
  padding-bottom: 12px;
`;

const DateInterval = styled.div`
  display: flex;
  gap: 4px;

  & span {
    color: ${(p) => p.theme.kallisto.color.text.static.textSecondary};
  }
`;

const TransportTitle = ({
  isTrain,
  departureDate,
  returnDate,
}: {
  isTrain: boolean;
  departureDate: string;
  returnDate: string;
}) => {
  const { t } = useTranslation();

  return (
    <TransportDetailsTitle>
      <Text variant="Title4">
        {isTrain
          ? t('vacation.select.train_detail_modal.train_title')
          : t('vacation.select.flight_detail_modal.flight_title')}
      </Text>
      <DateInterval>
        <CheckDateTime from={undefined} to={undefined} date={departureDate} />
        {' - '}
        <CheckDateTime from={undefined} to={undefined} date={returnDate} />
      </DateInterval>
    </TransportDetailsTitle>
  );
};

export default TransportTitle;
